import React from 'react';
import classes from './giveaway-landing-name.scss';
export const GiveawayLandingName = ({
  name,
  color
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.title,
    style: {
      color
    }
  }, name);
};